// import React, { useEffect, useState } from 'react';
// import colors from '../../Utils/colors';
// import images from '../../Utils/images';
// import { Card } from 'react-bootstrap';

// export default function PremiumPlans() {
//   const [planType, setPlanType] = useState('Monthly');
//   useEffect(() => {}, []);
//   const [selectedPlan, setSelectedPlan] = useState('Pro');

//   const GroupBtn = ({ title, subTitle }) => {
//     const status = title === planType;
//     return (
//       <button
//         onClick={() => setPlanType(title)}
//         type="button"
//         style={{
//           backgroundColor: status ? colors.themeBlue : colors.white,
//           borderWidth: 0,
//           height: 40,
//           width: `${100 / 3}%`,
//           //   borderRadius: title == "Quarterly" ? 0 : 4,
//           borderLeftWidth: title === 'Quarterly' ? 1 : 0,
//           borderRightWidth: title === 'Quarterly' ? 1 : 0,
//         }}
//       >
//         <div
//           style={{
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//           }}
//         >
//           <text
//             style={{
//               fontSize: 14,
//               color: status ? colors.white : colors.black,
//               fontWeight: 'bold',
//             }}
//           >
//             {title}
//           </text>
//           <text
//             style={{
//               fontSize: 10,
//               color: status ? colors.white : colors.themeBlue,
//               fontWeight: 'lighter',
//             }}
//           >
//             {subTitle}
//           </text>
//         </div>
//       </button>
//     );
//   };

//   const TextWithCheck = ({ txt, count, status }) => {
//     return (
//       <div
//         style={{
//           marginTop: 8,
//           alignItems: 'flex-start',
//           width: '70%',
//           marginLeft: '10%',
//         }}
//       >
//         <img
//           src={status ? images.activeTick : images.disableTick}
//           style={{ height: 8, width: 10, marginRight: 4 }}
//         />
//         <text
//           style={{
//             fontSize: 13,
//             color: colors.greys04,
//             fontWeight: 'normal',
//             marginLeft: 5,
//             marginRight: 5,
//           }}
//         >
//           {txt}
//         </text>
//         {count ? (
//           <text
//             style={{
//               fontSize: 14,
//               color: colors.black,
//               fontWeight: 'bold',
//             }}
//           >
//             {count}
//           </text>
//         ) : (
//           <></>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div style={styles.container}>
//       <text style={styles.boldTxt}>Choose a plan that’s best for you</text>
//       <div style={styles.gBtnContainer}>
//         <GroupBtn title={'Monthly'} subTitle={''} />
//         <GroupBtn title={'Quarterly'} subTitle={'EXTRA 10% OFF'} />
//         <GroupBtn title={'Yearly'} subTitle={'EXTRA 20% OFF'} />
//       </div>
//       <div
//         className="d-flex"
//         style={{
//           width: '96%',
//           border: `1px solid ${colors.greys03}`,
//           borderRadius: 5,
//           marginTop: 40,
//         }}
//       >
//         {/* FreeTrial */}
//         <div
//           onClick={() => setSelectedPlan('Free')}
//           className={`flex-fill ${selectedPlan === 'Free' ? `border border-success` : ''}`}
//           style={{ ...styles.body, borderWidth: 1, borderColor: colors.green }}
//         >
//           <text style={{ ...styles.boldTxt, marginTop: 10 }}>Free Trial</text>
//           <text
//             style={{
//               ...styles.boldTxt,
//               fontWeight: 'normal',
//               marginTop: 6,
//               marginBottom: 20,
//             }}
//           >
//             ₹0
//           </text>
//           <div
//             style={{
//               backgroundColor: colors.white04,
//               padding: 16,
//               paddingTop: 5,
//               paddingBottom: 5,
//               borderRadius: 2,
//             }}
//           >
//             <text style={{ ...styles.txt }}>Additional setup charges</text>
//           </div>

//           <div
//             style={{
//               width: '90%',
//               backgroundColor: colors.greys03,
//               height: 1,
//               marginTop: 12,
//               marginBottom: 12,
//             }}
//           />
//           <TextWithCheck status={true} txt={'Email Credits'} count={'(100)'} />
//           <TextWithCheck status={true} txt={'SMS Credits'} count={'(100)'} />
//           <TextWithCheck status={true} txt={'WhatsApp Credits'} count={'(100)'} />
//           <TextWithCheck status={true} txt={'Support timeline'} count={'(5 days)'} />
//           <TextWithCheck status={true} txt={'Devices login'} count={'(1)'} />
//           <TextWithCheck status={true} txt={'Analytics'} count={'(Basic)'} />
//           <TextWithCheck status={false} txt={'Payment Links'} />
//           <TextWithCheck status={false} txt={'Custom WhatsApp business account integration'} />
//           <TextWithCheck status={false} txt={'Custom Email integration'} />
//           <TextWithCheck status={false} txt={'Download reports'} />
//           <button
//             type="button"
//             className="btn btn-dark"
//             disabled={selectedPlan !== 'Free'}
//             style={{ width: '50%', marginTop: '10%', marginBottom: '5%' }}
//           >
//             Buy Now
//           </button>
//         </div>
//         {/* Growth */}
//         <div
//           onClick={() => setSelectedPlan('Growth')}
//           className={`flex-fill ${selectedPlan === 'Growth' ? `border border-success` : ''}`}
//           style={styles.body}
//         >
//           <text style={{ ...styles.boldTxt, marginTop: 10 }}>Growth</text>
//           <text
//             style={{
//               ...styles.boldTxt,
//               fontWeight: 'normal',
//               marginTop: 6,
//               marginBottom: 20,
//             }}
//           >
//             ₹1200
//           </text>
//           <div
//             style={{
//               backgroundColor: colors.white04,
//               padding: 16,
//               paddingTop: 5,
//               paddingBottom: 5,
//               borderRadius: 2,
//             }}
//           >
//             <text style={{ ...styles.txt }}>Additional setup charges</text>
//           </div>
//           <div
//             style={{
//               width: '90%',
//               backgroundColor: colors.greys03,
//               height: 1,
//               marginTop: 12,
//               marginBottom: 12,
//             }}
//           />
//           <TextWithCheck status={true} txt={'Email Credits'} count={'(1500)'} />
//           <TextWithCheck status={true} txt={'SMS Credits'} count={'(800)'} />
//           <TextWithCheck status={true} txt={'WhatsApp Credits'} count={'(200)'} />
//           <TextWithCheck status={true} txt={'Support timeline'} count={'(3 days)'} />
//           <TextWithCheck status={true} txt={'Devices login'} count={'(Upto 2)'} />
//           <TextWithCheck status={true} txt={'Analytics'} count={'(Basic)'} />
//           <TextWithCheck status={true} txt={'Payment Links'} />
//           <TextWithCheck status={true} txt={'Custom WhatsApp business account integration'} />
//           <TextWithCheck status={false} txt={'Custom Email integration'} />
//           <TextWithCheck status={false} txt={'Download reports'} />
//           <button
//             type="button"
//             className="btn btn-dark"
//             disabled={selectedPlan !== 'Growth'}
//             style={{ width: '50%', marginTop: '10%', marginBottom: '5%' }}
//           >
//             Buy Now
//           </button>
//         </div>
//         {/* Pro */}
//         <div
//           onClick={() => setSelectedPlan('Pro')}
//           className={`flex-fill ${selectedPlan === 'Pro' ? `border border-success` : ''}`}
//           style={styles.body}
//         >
//           <text style={{ ...styles.boldTxt, marginTop: 10 }}>Pro</text>
//           <text
//             style={{
//               ...styles.boldTxt,
//               fontWeight: 'normal',
//               marginTop: 6,
//               marginBottom: 20,
//             }}
//           >
//             ₹1800
//           </text>
//           <div
//             style={{
//               backgroundColor: colors.green,
//               padding: 16,
//               paddingTop: 5,
//               paddingBottom: 5,
//               borderRadius: 2,
//             }}
//           >
//             <text style={{ ...styles.txt, color: colors.white }}>No setup charges</text>
//           </div>
//           <div
//             style={{
//               width: '90%',
//               backgroundColor: colors.greys03,
//               height: 1,
//               marginTop: 12,
//               marginBottom: 12,
//             }}
//           />
//           <TextWithCheck status={true} txt={'Email Credits'} count={'(2500)'} />
//           <TextWithCheck status={true} txt={'SMS Credits'} count={'(1250)'} />
//           <TextWithCheck status={true} txt={'WhatsApp Credits'} count={'(300)'} />
//           <TextWithCheck status={true} txt={'Support timeline'} count={'(1 day)'} />
//           <TextWithCheck status={true} txt={'Devices login'} count={'(Upto 5)'} />
//           <TextWithCheck status={true} txt={'Analytics'} count={'(Advanced)'} />
//           <TextWithCheck status={true} txt={'Payment Links'} />
//           <TextWithCheck status={true} txt={'Custom WhatsApp business account integration'} />
//           <TextWithCheck status={true} txt={'Custom Email integration'} />
//           <TextWithCheck status={false} txt={'Download reports'} />
//           <button
//             type="button"
//             className={`btn btn-dark`}
//             disabled={selectedPlan !== 'Pro'}
//             style={{ width: '50%', marginTop: '10%', marginBottom: '5%' }}
//           >
//             Buy Now
//           </button>
//         </div>
//         {/* Enterprise */}
//         <div
//           onClick={() => setSelectedPlan('Enterprise')}
//           className={`flex-fill ${selectedPlan === 'Enterprise' ? `border border-success` : ''}`}
//           style={styles.body}
//         >
//           <text style={{ ...styles.boldTxt, marginTop: 10 }}>Enterprise</text>
//           <text
//             style={{
//               ...styles.boldTxt,
//               fontWeight: 'normal',
//               marginTop: 6,
//               marginBottom: 20,
//             }}
//           >
//             ₹2400
//           </text>
//           <div
//             style={{
//               backgroundColor: colors.green,
//               padding: 16,
//               paddingTop: 5,
//               paddingBottom: 5,
//               borderRadius: 2,
//             }}
//           >
//             <text style={{ ...styles.txt, color: colors.white }}>No setup charges</text>
//           </div>
//           <div
//             style={{
//               width: '90%',
//               backgroundColor: colors.greys03,
//               height: 1,
//               marginTop: 12,
//               marginBottom: 12,
//             }}
//           />
//           <TextWithCheck status={true} txt={'Email Credits'} count={'(3500)'} />
//           <TextWithCheck status={true} txt={'SMS Credits'} count={'(1600)'} />
//           <TextWithCheck status={true} txt={'WhatsApp Credits'} count={'(500)'} />
//           <TextWithCheck status={true} txt={'Support timeline'} count={'(4 hours)'} />
//           <TextWithCheck status={true} txt={'Devices login'} count={'(Upto 10)'} />
//           <TextWithCheck status={true} txt={'Analytics'} count={'(Advanced)'} />
//           <TextWithCheck status={true} txt={'Payment Links'} />
//           <TextWithCheck status={true} txt={'Custom WhatsApp business account integration'} />
//           <TextWithCheck status={true} txt={'Custom Email integration'} />
//           <TextWithCheck status={true} txt={'Download reports'} />

//           <button
//             type="button"
//             className={`btn btn-dark`}
//             disabled={selectedPlan !== 'Enterprise'}
//             style={{ width: '50%', marginTop: '10%', marginBottom: '5%' }}
//           >
//             Buy Now
//           </button>
//         </div>
//       </div>
//       <Card style={{ padding: 20, marginTop: 30, width: '96%', marginBottom: 30 }}>
//         <text style={{ ...styles.boldTxt, marginTop: 4, fontSize: 18 }}>NOTE</text>
//         <div className="d-flex bd-highlight">
//           <div className="p-2 w-100 bd-highlight">
//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//               }}
//             >
//               <p style={{ margin: 0, marginTop: 12 }}>
//                 &#9642; Support will be available on working business days only.
//               </p>
//               <p style={{ margin: 0, marginTop: 12 }}>&#9642; We do not shy away from challenges</p>
//               <p style={{ margin: 0, marginTop: 12 }}>&#9642; All pricing is exclusive of GST.</p>
//             </div>
//           </div>
//           <div
//             className="p-2 w-100 flex-shrink-1 bd-highlight"
//             style={{
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//             }}
//           >
//             <button
//               type="button"
//               className="btn btn-outline-dark"
//               style={{
//                 marginLeft: 'auto',
//                 paddingLeft: 40,
//                 paddingRight: 40,
//                 fontSize: 15,
//               }}
//             >
//               View top up plans
//             </button>
//           </div>
//         </div>
//       </Card>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   boldTxt: {
//     fontWeight: 'bold',
//     fontSize: 22,
//     color: colors.black,
//     marginTop: 20,
//   },
//   gBtnContainer: {
//     display: 'flex',
//     width: '60%',
//     alignItems: 'center',
//     border: `1px solid ${colors.greys03}`,
//     borderRadius: 5,
//     overflow: 'hidden',
//     marginTop: 30,
//   },
//   body: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
//   txt: {
//     fontSize: 14,
//     color: colors.greys01,
//   },
// };

// EnterprisePlan.jsx
import React from "react";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import images from "../../Utils/images";
import { useNavigate } from "react-router-dom";

const PRIMARY = "#7755F8";
const BORDER = "#E6E6F0";

const Tick = () => (
  <CheckCircleRoundedIcon
    fontSize="small"
    sx={{ color: PRIMARY, mr: 1, mt: "2px", flex: "0 0 auto" }}
  />
);

const SectionHeader = ({ children }) => (
  <p className="fw-semibold mb-2" style={{ color: "#444", marginTop: 16 }}>
    {children}
  </p>
);

const Bullet = ({ children }) => (
  <li className="d-flex align-items-start mb-2" style={{ listStyle: "none" }}>
    <Tick />
    <span className="text-muted">{children}</span>
  </li>
);

export default function EnterprisePlan({
  agents = [
    { name: "Ritul", phone: "+91 89290 02841" },
    { name: "Vandana", phone: "+91 88272 13902" },
    { name: "Sreenavya", phone: "+91 72048 10343" },
    { name: "Gargi", phone: "+91 85238 95571" },
  ],
  illustrationSrc = images.Illustration_Enterprise, 
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedAgent, setSelectedAgent] = React.useState(null);

  const open = Boolean(anchorEl);

  const openMenu = (e) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleSelect = (agent) => {
    setSelectedAgent(agent);
    closeMenu();
  };

  const navigate = useNavigate()

  return (
    <div className="container my-4 my-md-5">
      <div>
        <img 
          src={images.BackArrowBlack} 
          style={{height:24,width:24,objectFit:"contain",cursor:"pointer",marginBlockEnd:20}} 
          onClick={()=>{navigate('/creator')}}
        />
      </div>
      <div
        className="position-relative p-4 p-md-5 bg-white"
        style={{
          borderRadius: 16,
          border: `1px solid ${BORDER}`,
          boxShadow: "0 6px 18px rgba(20,20,43,.06)",
        }}
      >
        <div className="position-absolute" style={{ top: 16, right: 16, zIndex: 2 }}>
          <Button
            id="contact-manager-btn"
            variant="contained"
            onClick={openMenu}
            endIcon={<ExpandMoreIcon />}
            sx={{
              textTransform: "none",
              backgroundColor: PRIMARY,
              "&:hover": { backgroundColor: "#6947e9" },
              borderRadius: 2,
              py: 1,
              px: 2,
              boxShadow: "0 6px 14px rgba(119,85,248,.25)",
            }}
          >
            Contact Account Manager
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={closeMenu}
            MenuListProps={{ "aria-labelledby": "contact-manager-btn" }}
            elevation={6}
            PaperProps={{ sx: { borderRadius: 2, mt: 1 } }}
          >
            {agents.map((a) => (
              <MenuItem key={a.phone} onClick={() => handleSelect(a)}>
                {a.name}
              </MenuItem>
            ))}
          </Menu>

          {/* Show phone number if agent selected */}
          {selectedAgent && (
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                textAlign: "right",
                color: "#444",
                fontWeight: 500,
              }}
            >
              {selectedAgent.name}: {selectedAgent.phone}
            </Typography>
          )}
        </div>

        <h1 className="fw-bold mb-1" style={{ letterSpacing: "-0.3px" }}>
          Enterprise Plan
        </h1>
        <p className="text-muted mb-4">
          Your comprehensive plan that scales with your business
        </p>

        <div className="row g-4 align-items-start">
          <div className="col-lg-7">
            <div className="row">
              <div className="col-md-6">
                <p className="fw-semibold mb-2">Features</p>
                <ul className="p-0 m-0">
                  <Bullet>WhatsApp Chatbot Builder</Bullet>
                  <Bullet>Instagram Chatbot Builder</Bullet>
                  <Bullet>Meta Ads Manager</Bullet>
                  <Bullet>Email Warmup &amp; Sequences</Bullet>
                  <Bullet>Email Automation</Bullet>
                  <Bullet>Landing Page Forms</Bullet>
                  <Bullet>Custom AI Agents</Bullet>
                  <Bullet>Automation Tasks</Bullet>
                  <Bullet>Analytics Dashboard &amp; Reports</Bullet>
                  <Bullet>WhatsApp Team Inbox</Bullet>
                  <Bullet>Instagram Team Inbox</Bullet>
                  <Bullet>Mobile App Support</Bullet>
                  <Bullet>Agent Logins</Bullet>
                  <Bullet>Contacts Management</Bullet>
                  <Bullet>Developer API Library</Bullet>
                  <Bullet>Dedicated Server</Bullet>
                </ul>
              </div>

              <div className="col-md-6 position-relative">
                <div
                  className="d-none d-md-block position-absolute top-0 bottom-0"
                  style={{
                    left: -12,
                    width: 0,
                    borderRight: "2px dotted #b7b7d8",
                    opacity: 0.8,
                  }}
                />
                <p className="fw-semibold mb-2">Channels</p>
                <ul className="p-0 m-0">
                  <Bullet>WhatsApp API Messaging</Bullet>
                  <Bullet>Email API Messaging</Bullet>
                  <Bullet>Instagram Messaging</Bullet>
                  <Bullet>Global SMS Messaging</Bullet>
                  <Bullet>RCS Business Messaging</Bullet>
                </ul>

                <SectionHeader>Customer Support</SectionHeader>
                <ul className="p-0 m-0">
                  <Bullet>Dedicated Account Manager</Bullet>
                  <Bullet>Email &amp; WhatsApp Support</Bullet>
                  <Bullet>On-Demand Support Call</Bullet>
                </ul>

                <SectionHeader>Technical Support</SectionHeader>
                <ul className="p-0 m-0">
                  <Bullet>On-Demand Tech Support Call</Bullet>
                  <Bullet>Custom Feature Development</Bullet>
                </ul>

                <SectionHeader>Integration</SectionHeader>
                <ul className="p-0 m-0">
                  <Bullet>10+ Integrations</Bullet>
                  <Bullet>Webhook support</Bullet>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="w-100 d-flex justify-content-center justify-content-lg-end">
              <img
                src={illustrationSrc}
                alt="Enterprise growth illustration"
                className="img-fluid"
                style={{
                  maxWidth: 520,
                  width: "100%",
                  borderRadius: 12,
                  boxShadow: "0 8px 24px rgba(20,20,43,.06)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

